(() => {
  if (window.ytJournalCountsReady) return;
  window.ytJournalCountsReady = true;

  const loadCounts = async () => {
    const groups = new Map();
    document.querySelectorAll('#site-header a[data-yt-journal-count-link]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      url.search = '';
      url.hash = '';
      const key = url.href;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(link);
    });

    const heading = document.querySelector('h2[data-yt-journal-view-count]');
    const pageUrl = new URL(window.location.href);
    pageUrl.search = '';
    pageUrl.hash = '';

    const display = (links, count) => {
      links.forEach((link) => {
        const counter = link.querySelector('[data-yt-journal-count]');
        if (!counter) return;
        counter.textContent = ` (${count})`;
        counter.hidden = false;
      });
    };

    await Promise.allSettled(Array.from(groups, async ([key, links]) => {
      const seededCount = heading && key === pageUrl.href
        ? heading.getAttribute('data-yt-journal-view-count')
        : null;
      if (seededCount !== null && /^\d+$/.test(seededCount)) {
        display(links, Number(seededCount));
        return;
      }
      const url = new URL(key);
      url.searchParams.set('view', 'yt-journal-count');
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url.href, {
          credentials: 'same-origin',
          cache: 'no-store',
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Journal count unavailable');
        const content = await response.text();
        const parsed = new DOMParser().parseFromString(content, 'text/html');
        const value = parsed.querySelector('[data-yt-journal-total]')?.getAttribute('data-yt-journal-total');
        if (value === null || value === undefined || !/^\d+$/.test(value)) {
          throw new Error('Journal count invalid');
        }
        const count = Number(value);
        if (!Number.isSafeInteger(count)) throw new Error('Journal count invalid');
        display(links, count);
      } catch {
        links.forEach((link) => {
          const counter = link.querySelector('[data-yt-journal-count]');
          if (counter) counter.hidden = true;
        });
      } finally {
        window.clearTimeout(timeout);
      }
    }));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCounts, { once: true });
  } else {
    loadCounts();
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) loadCounts();
  });
})();
